import axios from "axios";

const API_URL = "/api/cms/informes/by-module/CARTEIRA_PESCA";

export async function fetchInformes() {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    throw error;
  }
}
